import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.75 3.75L12 9L6.75 14.25", stroke: "#CA7D69", strokeWidth: 2, strokeMiterlimit: 10 }));
export default SvgArrowRight;
